export const COHORT_REFETCH_INTERVAL = 15 * 60 * 1000; // 15 minutes

export const COHORT_KEYS = {
  FIRST_QP_SUBMIT: 'has_played_quickpicks',
  FIRST_CONTEST: 'has_played_contest',
  POTENTIAL_WHALER: 'potential_whaler',
};

export type UserCohort = {
  cohortKey: string;
  userId: string;
  receivedAt: string; // Date-time
};

export type GetUserCohortPayload = {
  page?: number;
  pageSize?: number;
};

export type GetUserCohortsResponse = {
  id: string;
  pageSize: number;
  totalPages: number;
  totalCount: number;
  data: UserCohort[];
};
